import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {KeyboardActionsEnum} from '../../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export interface EventViewerButtonDefinition {
  id: string;
  icon: IconName;
  title: ReactNode;
  isDisabled: boolean;
  isDropdownOnly: boolean;
  onClick: () => void;
  keyboardAction?: KeyboardActionsEnum;
}

interface CalendarEventViewerHeaderMoreButtonProps {
  buttons: ReadonlyArray<EventViewerButtonDefinition>;
}

/*
 * Style.
 */

const StyledMoreDiv = styled.div`
  transform: rotateZ(90deg);
`;

/*
 * Component.
 */

export const CalendarEventViewerHeaderMoreButton: FC<CalendarEventViewerHeaderMoreButtonProps> = (props) => {
  const theme = useUserTheme();
  const {buttons} = props;

  const renderButton: RendererOf<boolean> = (isOpen) => (
    <StyledMoreDiv>
      <IconButton
        iconName="more"
        color={theme.greys.shade80}
        hoverColor={theme.greys.shade80}
        label={<Trans id="calendar-event-viewer-header-more">More</Trans>}
        hasHover={isOpen}
      />
    </StyledMoreDiv>
  );

  const renderDropdown: RendererOf<PopoverTransferProps> = (popoverProps) => (
    <SimpleDropdown {...popoverProps}>
      {buttons.map(({id, title, isDisabled, onClick}) => (
        <SimpleDropdownItem key={id} onSelect={onClick} isDisabled={isDisabled}>
          {title}
        </SimpleDropdownItem>
      ))}
    </SimpleDropdown>
  );

  return <PopoverCoordinator renderButton={renderButton} renderModal={renderDropdown} />;
};
